import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../../../../api";
import { storageQueries } from "../../../../hooks/useStorage";
import urls from "../../../../urls";
import type { Storage } from "../../../../utils/backend-types";
import { COMPONENT_QUERY_KEY } from "../../../../utils/constants";
import { ObjectName } from "../../../../utils/enums";

function useStorageMutation(siteId?: number) {
  const queryClient = useQueryClient();
  return {
    createStorage: useMutation({
      mutationFn: createStorage,
      onSuccess: () =>
        queryClient.invalidateQueries({
          queryKey: [
            COMPONENT_QUERY_KEY[ObjectName.Storage],
            { siteOrVariantId: siteId }
          ]
        })
    }),
    editStorage: useMutation({
      mutationFn: editStorage,
      onSuccess: (responseData) => {
        queryClient.invalidateQueries({
          queryKey: [ObjectName.Storage, { siteOrVariantId: siteId }] // useConfiguratorComponents for storage
        });
        queryClient.invalidateQueries({
          queryKey: [
            COMPONENT_QUERY_KEY[ObjectName.Storage],
            { siteOrVariantId: siteId }
          ]
        });
        queryClient.invalidateQueries({
          queryKey: storageQueries.detail(responseData.id).queryKey
        });
      }
    })
  };
}

async function createStorage({
  siteId,
  newStorage
}: {
  siteId: number;
  newStorage: Storage;
}) {
  const response = await api.post<Storage>(
    urls.api.storages(siteId),
    newStorage
  );
  return response.data;
}

async function editStorage(editedStorage: Storage) {
  const response = await api.put<Storage>(
    urls.api.storage(editedStorage.id),
    editedStorage
  );
  return response.data;
}

export { useStorageMutation };
